








import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Action, Mutation, Getter } from 'vuex-class'
import LaunchPadApps from '@/components/Appstore/LaunchPadApps.vue'
import { LaunchPadInitialData } from '@/pages/appstore/entities/appstore'
import { tabTypes } from '@/pages/appstore/entities/subMenu'

@Component<LaunchPadWidget>({
    components: {
        LaunchPadApps
    }
})
export default class LaunchPadWidget extends Vue {
    public loading = true

    @Prop({ type: Object, required: true })
    public readonly launchPadInitialData!: LaunchPadInitialData
    @Prop({ type: Boolean, required: false, default: false })
    public readonly inAppstore!: boolean
    @Prop({ type: String, required: false, default: '' })
    public readonly appstoreTab!: string

    @Mutation public setLaunchPadBasics
    @Action public setAjaxClients
    @Action public loadAllApps
    @Action public loadInstalledAppsNames
    @Getter public getLaunchPadApps
    @Getter public getInstalledAppsNames
    @Getter public getAllApps

    public get tabTypes() {
        return tabTypes
    }

    public get canViewLaunchPad(): boolean {
        return (
            this.launchPadInitialData.visibleToCurrentUserOutAppStore ||
            this.inAppstore
        )
    }

    public async setLaunchPadInitialData() {
        this.setLaunchPadBasics(this.launchPadInitialData)
        if (this.getAllApps.length === 0) {
            this.setAjaxClients()
            await this.loadAllApps()
            await this.loadInstalledAppsNames()
        }
        this.loading = false
    }

    public mounted() {
        if (this.canViewLaunchPad) {
            this.setLaunchPadInitialData()
        }
    }
}
